import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-tooltip';
import { AuthModule } from '../../auth/auth.module';
import { CardPaymentModule } from '../../components/common/card.payment/card.payment.module';
import { BlockUIModule } from 'ng-block-ui';
import { CompetitorsComponent } from './competitors.component';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { AddCompetitorsComponent } from './add.competitors.component';
import { BaseCompetitorsComponent } from './base.competitors.component';
import { ViewCompetitorsComponent } from './view.competitors.component';
import { CompetitorAwardsComponent } from './competitor.awards.component';
import { CompetitorNoticeComponent } from './competitor.notice.component';
import { ContractAwardsModule } from '../contract.awards/contract.awards.module';
import { CompetitorModalComponent } from './competitor.modal.component';
import { DateRangeModule } from '../../components/common/date.range/date.range.module';
import { CompetitorHelpComponent } from './competitor.help.component';
import { SafeHtmlPipeModule } from '../../components/pipes/safehtml.pipe/safe.html.pipe.module';
import { CompetitorAwardsTableComponent } from './competitor.awards.table.component';

@NgModule({
    declarations: [CompetitorsComponent, AddCompetitorsComponent, BaseCompetitorsComponent, ViewCompetitorsComponent, CompetitorAwardsComponent, CompetitorAwardsTableComponent, CompetitorNoticeComponent, CompetitorModalComponent, CompetitorHelpComponent],
    imports: [BrowserModule, FormsModule, PagingModule, RouterModule, TooltipModule, AuthModule, CardPaymentModule, BlockUIModule, B2BAngularMaterialModule, ContractAwardsModule, DateRangeModule, SafeHtmlPipeModule]
})

export class CompetitorsModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/competitors/competitors.module.ts